import moment from "moment";
import { ref, computed } from "vue";

export default () => {
  const selectedFrequency = ref("");
  const dateFrom = ref();
  const dateTo = ref();
  const selectedCategory = ref("");

  const frequencyHandler = () => {
    switch (selectedFrequency.value) {
      case "1":
        dateFrom.value = moment()
          .subtract(1, "M")
          .startOf("month")
          .format("YYYY-MM-DD");
        dateTo.value = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "3":
        dateFrom.value = moment()
          .subtract(3, "M")
          .startOf("month")
          .format("YYYY-MM-DD");
        dateTo.value = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "6":
        dateFrom.value = moment()
          .subtract(6, "M")
          .startOf("month")
          .format("YYYY-MM-DD");
        dateTo.value = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "12":
        dateFrom.value = moment()
          .subtract(12, "M")
          .startOf("month")
          .format("YYYY-MM-DD");
        dateTo.value = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      default:
        dateFrom.value = moment().startOf("year").format("YYYY-MM-DD");
        dateTo.value = moment().format("YYYY-MM-DD");
    }
  };

  const selectedCategoryName = computed(() => {
    if (
      typeof selectedCategory.value === "object" &&
      selectedCategory.value !== null
    ) {
      return selectedCategory.value.categoryName;
    }
    return selectedCategory.value;
  });

  return {
    selectedFrequency,
    dateFrom,
    dateTo,
    selectedCategory,
    selectedCategoryName,
    frequencyHandler,
  };
};
